import { render, staticRenderFns } from "./AnalResultPratoComponent.vue?vue&type=template&id=b562f590&scoped=true"
import script from "./AnalResultPratoComponent.vue?vue&type=script&lang=js"
export * from "./AnalResultPratoComponent.vue?vue&type=script&lang=js"
import style0 from "./AnalResultPratoComponent.vue?vue&type=style&index=0&id=b562f590&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b562f590",
  null
  
)

export default component.exports